// vue
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';

export const useFeatureService = () => {

    // properties
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    // methods
    const getTotalFeatureAreas = async (
        courseSchemaId: string
        ) => {
        const res = await axios.get(`${apiUrl}/course/${courseSchemaId}/feature-area`);     
        return res.data;
    };

    const getFeatureAreasByHole = async (
        holenumber: number,
        cousrseSchemaId :string
    ) => {
        const res = await axios.get(
            `${apiUrl}/course/${cousrseSchemaId}/feature-area/hole/${holenumber}`);
        return res.data;
    };

    return {
        getTotalFeatureAreas,
        getFeatureAreasByHole,
    };
};
